import { render } from "./CalendarDays.vue?vue&type=template&id=33de1fbb&scoped=true"
import script from "./CalendarDays.vue?vue&type=script&lang=js"
export * from "./CalendarDays.vue?vue&type=script&lang=js"

import "./CalendarDays.vue?vue&type=style&index=0&id=33de1fbb&scoped=true&lang=css"

import exportComponent from "/var/www/boa/bo/frontend/boa/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33de1fbb"]])

export default __exports__